import axios from 'axios'

function capitalize(text) {
  return text.replace(/(?:^|\s)\S/g, word => word.toUpperCase())
}

function formatPrice(price) {
  return `$ ${(price / 100).toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
}

const getData = (function() {
  return async url => {
    const { data } = await axios.get(url)
    console.log('🔎 requesting...')
    return data
  }
})()

const getAndCache = (function() {
  const cache = {}
  return async (keyCache, url) => {
    if (cache[keyCache]) {
      console.log('💾 from cache...')
      return Promise.resolve(cache[keyCache])
    }
    const { data } = await axios.get(url)
    console.log('🔎 fresh request...')
    cache[keyCache] = data
    return data
  }
})()

const postData = (function() {
  return async (url, payload) => {
    const { data } = await axios.post(url, payload)
    console.log('🔎 requesting...')
    return data
  }
})()

export { capitalize, formatPrice, getData, getAndCache, postData }



// WEBPACK FOOTER //
// ./src/ducks/utils/index.js